import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../config/app-settings';
import { Client } from "elasticsearch";
import { AngularFireDatabaseWrapper } from '../providers/angularfire-wrapper';

import {Events} from 'ionic-angular';
//import { EventCodes } from '../core/codes';
import _ from 'lodash';
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeAll';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/fromPromise';


@Injectable()
export class ElasticSearchService  {
    private _client: any;
    private elasticHost: string;
    private elasticAuth: string;
    constructor(public settings: AppSettings, public afw: AngularFireDatabaseWrapper, public events: Events) {
        if(this._client){
            return;
        }
        if(!this.settings.elasticSearch ||  !this.settings.elasticSearch.config || !this.settings.elasticSearch.config.host){
            this.settings.getData().subscribe(sets=>{
                this.elasticHost = this.settings.elasticSearch.config.host;
                this.elasticAuth = this.settings.elasticSearch.config.auth;
                this._connect();
            })
        }
        else{
            this.elasticHost = this.settings.elasticSearch.config.host;
            this.elasticAuth = this.settings.elasticSearch.config.auth;
            this._connect();
        }
    }

    private _connect() {
        this._client = new Client({
            host: this.elasticHost,
            httpAuth: this.elasticAuth
        });
    }

    public Search(query,childRef,isIds?: boolean) {
      var result = {
          items: [],
          totalRecords : 0,
          pages: 0
      };
      let src =  Observable.fromPromise(this._client.search(query))
      if(isIds){
        src = src.map((response:any)=>{
            if(!response.hits || !response.hits.hits || !response.hits.total){
                return Observable.from([result]);
            }
            return this.convertDataByIds(response.hits.hits,childRef).map((items:any)=>{
                return {
                    items: items,
                    totalRecords: response.hits.total,
                    pages: Math.ceil(response.hits.total / query.size)
                };
            });
        })
        .mergeAll();
      }
      else {
          src = src.map((response:any)=>{
              return {
                  items: this.convertDataSnapshot(response.hits.hits),
                  totalRecords: response.hits.total,
                  pages: Math.ceil(response.hits.total / query.size)
              }
          });
      }
      return src;	
    }

    private convertDataSnapshot(obj){
          let rs;
          rs = _.map(obj, val=> {
              var data = val['_source'];
              data.$id = val['_id'];
              return data;
          });
          return rs;
    }

    private convertDataByIds(obj,childRef){
        let rs;
        rs = _.map(obj, val => {
            return val['_id'];
        });
        return this.getListItems(rs,childRef);
    }

    private getListItems(ids,childRef){
        let src = _.map(ids, id=>{
            return this.afw.object('/'+childRef+'/'+id);
        });
        return Observable.from(src).combineAll();
    }
}

export interface ElasticResult{
    items: Array<any>,
    totalRecords: number,
    pages: number
}


// WEBPACK FOOTER //
// ./src/providers/elastic-search.ts